import React, { useEffect, useState } from "react";
import { Box, Card, Divider, Grid, Tab, Paper, Container } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import CommonTabs from "src/components/CommonTabs/CommonTabs";
import TabHeader from "src/components/TabHeader/TabHeader";
import { NodConfigurationRoute } from "../../configuration.routes";
import { AddVehicleYard } from "./components/AddVehicleYard/AddYard";
import { AddVehicleYardRow } from "./components/AddVehicleYardRow/AddYardRow";
import { useStyles } from "./components/style";
import { formIsDirty, setisDirtyValue } from "src/app-redux/configuration/configurationSlice";
import { AddContainerYard } from "./components/AddContainerYard/AddYard";
import { AddContainerYardRow } from "./components/AddContainerYardRow/AddYardRow";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

type Props = {};
export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
export default function Yard({}: Props): React.ReactElement {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const moduleName = NodConfigurationRoute.title;
  const pageHeading = "Yards";
  const isDirty: boolean = useAppSelector(formIsDirty);
  const dispatch = useAppDispatch();
  const [showPrompt, setShowPrompt] = useState<boolean>(true);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    if (!isDirty) return setValue(newValue);

    // to show prompt on tab change
    if (showPrompt) {
      if (confirm("Changes you made may not be saved.")) {
        dispatch(setisDirtyValue(false));
        return setValue(newValue);
      } else {
        return setShowPrompt(false);
      }
    }
    setShowPrompt(true);
  };

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} link={NodConfigurationRoute.path} />
      <Box m={2} />
      <Grid container direction="row">
        <Grid item xs={12} md={12} className={classes.cardMainParent}>
          <Paper elevation={3} className={classes.cardMain}>
            <Box pl={2} pr={2}>
              <Grid container direction="row">
                <Grid item xs={12} md={7}>
                  <Typography className={classes.pageHeading}>{pageHeading}</Typography>
                </Grid>
              </Grid>
            </Box>
            <Box m={1}>
              <Divider />
            </Box>

            <Grid container>
              <Grid item xs={4} md={3} lg={2} component={Card}>
                <div className="configTabs">
                  <CommonTabs value={value} handleChange={handleChange} tabMinHeight={800}>
                    <Tab label="Add Vehicle Yard" {...a11yProps(0)} />
                    <Tab label="Add Vehicle Yard Row" {...a11yProps(1)} />
                    <Tab label="Add Container Yard" {...a11yProps(2)} />
                    <Tab label="Add Container Yard Row" {...a11yProps(3)} />
                  </CommonTabs>
                </div>
              </Grid>
              <Grid item xs={8} md={9} lg={10} component={Card} className={classes.tabCardContent}>
                <Container className="configSubTabs">
                  <AddVehicleYard value={value} index={0} />
                  <AddVehicleYardRow value={value} index={1} />
                  <AddContainerYard value={value} index={2} />
                  <AddContainerYardRow value={value} index={3} />
                </Container>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
